<style lang="css" scope>
  .wz-comment-list {
    height: calc(100vh - 2rem);
    padding: 0.2rem;   
    overflow: hidden;
    overflow-y: auto;
  }
  .wzapp .wz-comment-list{
    height: calc(100vh - 1.3rem);
  }
  .animlist-enter-active, .animlist-leave-active {
    transition: all 1s;
  }
  .animlist-enter, .animlist-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }
  .animlist-move {
	  transition: all 0.5s;
  }
  .iPhoneX .wz-comment-list, 
  .iPhoneXr .wz-comment-list, 
  .iPhoneXs .wz-comment-list {
    /* padding-bottom: 1.45rem; */
  }
</style>
<template>
  <div class="wz-comment-list"  ref="commentList" @scroll="commentScrooll($event)">
    <slot name="head"></slot>
    <div class="ta-center cl-gray" v-if="finished">暂无更多数据了</div>
    <template v-if="list && list.length">
      <div class="wz-comment-list__body" tag="div">
      <wz-comment-item
        v-for="comment in list"
        :key="comment.cid"
        :comment="comment"
        :users="userMap"
      ></wz-comment-item>
      </div>
    </template>
    
    <div v-else class="wz-comment-list__body">
      <k-no-data>暂无评论</k-no-data>
    </div>
    <slot name="foot"></slot>
  </div>
</template>

<script>
  import { commentList } from '../../api/g/comment'
  import {assign} from '../../utils/base'
  export default {
    name: 'wz-comment-list',
    data() {
      return {
        list: [],
        userMap: {},
        beforeCid : 0,
        finished : false,
        loading : false,
        loadMore : false,
        oldScrollHeight : 0,
        uploadTimer : null,
        timerLoop : 1000*60
      }
    },
    props: {
      objType: { type: [Number, String], default: 0 },
      objId: { type: [Number, String], default: 0 },
      start: { type: Number, default: 0 },
      pageNum: { type: Number, default: 20 },
      params: { type: Object, default: null }
    },
    computed: {
      query() {
        const { objType, objId, start, pageNum, params } = this
        return {
          ...params,
          totalFlag: 1,
          objType,
          objId,
          start,
          pageNum,
          scrollStatus : 0
        }
      }
    },
    methods: {
      user(uid) {
        return this.userMap[uid] || { uid: uid, nick: `xs_${uid}`, logoSrc: '' }
      },
      async fetch(args) {
        this.loading = true
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
        const { query } = this
        if(this.beforeCid && !this.finished && args && args.more){
          query.beforeCid = this.beforeCid
        }
        const { total, list, userMap } = await commentList(query)
        this.userMap = assign({},this.userMap, userMap)

        if(list && list.length){
          this.beforeCid = list[list.length-1].cid
          if(args && args.more){
            this.list = list.reverse().concat(this.list);
            this.loadMore = true
          } else {
            this.list =list.reverse();
            this.loadMore = false
          }
          if(list.length < query.pageNum){
            this.finished = true
          }

        } else {
          this.list = []
        }
        this.loading = false
        this.$toast.clear()
        // console.log(list)

        this.$emit('success', {
          query,
          total
        })
        if(!this.scrollStatus || (args && args.place != "timer")){
          this.commentSuccess()
        }

      },
      commentSuccess(data){
        console.log(data);

        setTimeout(()=>{
          if(this.oldScrollHeight && this.loadMore){
            this.$refs.commentList.scrollTo(0,this.$refs.commentList.scrollHeight-this.oldScrollHeight);
          } else {
            this.$refs.commentList.scrollTo(0,this.$refs.commentList.scrollHeight);
          }
          this.oldScrollHeight = this.$refs.commentList.scrollHeight
        },50);
      },
      commentScrooll: function(event) {
        var target = event.target
        if(target.scrollTop === 0){
          this.scrollStatus = 1 //顶部
          if(!this.loading && !this.finished){
            this.fetch({
              more : true
            })
          }
        } else if((target.scrollHeight - target.scrollTop - target.clientHeight) <= 1){
          this.scrollStatus = 0 //底部
        } else if ((target.scrollHeight - target.scrollTop - target.clientHeight) > 200){
          this.scrollStatus = 2 //跟离底部200
        } else {
          //this.scrollStatus = 3
        }
        //console.log(this.scrollStatus )
        //console.log(target.scrollHeight - target.scrollTop - target.clientHeight)
       // console.log(document.documentElement.scrollTop || document.body.scrollTop)
      },
      loadTimer(){
          this.fetch({place:"timer"});
          this.uploadTimer = setTimeout(()=>{
            this.loadTimer();
          }, this.timerLoop)
      }
    },
    watch: {
      query(nv, ov) {
        //this.scrollStatus = 0
        //this.fetch()
        if(nv.place = "post"){
          this.fetch({
            place : nv.place
          })
        }
      }
    },
    created() {
      this.fetch();
      //this.loadTimer();
    },
    beforeDestroy(){
      clearTimeout(this.uploadTimer)
      this.uploadTimer = null
    }
  }
</script>
